import janos_bacsi from '../img/janos_bacsi.jpg'
import './Founder.css'
import HeroCard from './HeroCard.jsx'
const Founder = () => {
    return <div>
        <HeroCard image={janos_bacsi} name={'VÁRADI JÁNOS'} title={'EDZŐ, A KLUB ALAPÍTÓJA'} description={'A Judo több, mint versenysport.'} isSquare={false} />
    </div>;
};

export default Founder;